import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { TaskDetailResponse } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { dateTimeFormatter } from "web_myplann/Shared/Utils/dateFormatters";
import { TaskDescription } from "web_myplann/Tasks/Components/TaskDescription";
import { TaskKeyValueRow } from "web_myplann/Tasks/Components/TaskKeyValueRow";

const R = Resources.Task.Detail;

type Props = {
	task: TaskDetailResponse;
	hasMoreAgents: boolean;
};

export const TaskBasicInfoSection: FC<Props> = ({ task, hasMoreAgents }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<Typography variant="sectionLabel">{t(R.BasicInfo.title)}</Typography>
			<Stack bgcolor="background.paper" pb={0.8} pt={0.4}>
				<TaskKeyValueRow label={t(R.BasicInfo.Name)} value={task.name} bold />
				<TaskKeyValueRow
					label={t(R.BasicInfo.Date)}
					value={dateTimeFormatter(task.dueDate)}
				/>
				{task.statusName && (
					<TaskKeyValueRow label={t(Resources.Activity.Detail.BasicInfo.State)}>
						<Typography
							component="span"
							variant="button"
							px={1}
							py={0.2}
							color={theme.palette.getContrastText(task.statusColor ?? "#000")}
							borderRadius={theme.shape.pillRadius}
							bgcolor={task.statusColor ?? undefined}
						>
							{task.statusName}
						</Typography>
					</TaskKeyValueRow>
				)}
				{hasMoreAgents && (
					<TaskKeyValueRow
						label={t(R.BasicInfo.CreatedBy)}
						value={`${task.author.name} (${t(Resources.Dashboard.UserType[task.author.type])})`}
					/>
				)}
				{task.assignedTo && (
					<TaskKeyValueRow
						label={t(R.BasicInfo.Solver)}
						value={`${task.assignedTo.name} (${t(Resources.Dashboard.UserType[task.assignedTo.type])})`}
					/>
				)}
				{task.description && (
					<TaskDescription
						label={t(R.BasicInfo.Desc)}
						text={task.description}
					/>
				)}
			</Stack>
		</>
	);
};
